import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  endOfDay,
  subWeeks,
  subMonths,
  subYears,
} from 'date-fns';

export type DateRangePreset =
  | 'this_week'
  | 'last_week'
  | 'this_month'
  | 'last_month'
  | 'this_year'
  | 'last_year'
  | 'custom';

export const DATE_RANGE_OPTIONS: { value: DateRangePreset; label: string }[] = [
  { value: 'this_week', label: 'This week' },
  { value: 'last_week', label: 'Last week' },
  { value: 'this_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'this_year', label: 'This year' },
  { value: 'last_year', label: 'Last year' },
  { value: 'custom', label: 'Custom' },
];

export function getDateRange(preset: Exclude<DateRangePreset, 'custom'>): {
  startDate: string;
  endDate: string;
} {
  const today = new Date();

  switch (preset) {
    case 'this_week':
      return {
        startDate: startOfWeek(today, { weekStartsOn: 0 }).toISOString(),
        endDate: endOfDay(today).toISOString(),
      };
    case 'last_week': {
      const lastWeek = subWeeks(today, 1);
      return {
        startDate: startOfWeek(lastWeek, { weekStartsOn: 0 }).toISOString(),
        endDate: endOfWeek(lastWeek, { weekStartsOn: 0 }).toISOString(),
      };
    }
    case 'this_month':
      return {
        startDate: startOfMonth(today).toISOString(),
        endDate: endOfDay(today).toISOString(),
      };
    case 'last_month': {
      const lastMonth = subMonths(today, 1);
      return {
        startDate: startOfMonth(lastMonth).toISOString(),
        endDate: endOfMonth(lastMonth).toISOString(),
      };
    }
    case 'this_year':
      return {
        startDate: startOfYear(today).toISOString(),
        endDate: endOfDay(today).toISOString(),
      };
    case 'last_year': {
      const lastYear = subYears(today, 1);
      return {
        startDate: startOfYear(lastYear).toISOString(),
        endDate: endOfYear(lastYear).toISOString(),
      };
    }
  }
}
